import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { SelectCustom, SelectCustomOption } from '@americanexpress/dls-react';
import { useRoomsContext } from '../../contexts/roomsContext';
import { IN_LAP, IN_SEAT } from '../../constants/dropdownConstants';
import { useConfigContext } from '../../contexts/configContext';
import { hasInfantsInLapOnlyRule } from '../../constants/featureConstants';
import styles from './Infants.scss';

const InfantsVariant = ({ isMultiRoom, roomIndex }) => {
  const { rooms, updateInfantInLap } = useRoomsContext();
  const infantsInLap = useConditionalFeature(hasInfantsInLapOnlyRule);
  const { moduleId } = useConfigContext();
  const { infants } = rooms[roomIndex];
  const { formatMessage } = useIntl();

  const roomId = roomIndex + 1;

  const infantIdPrefix = `${moduleId}-room-${roomId}-infant`;
  const infantsDropdownOptions = [
    {
      value: IN_LAP,
      label: formatMessage({ id: 'in_lap' }),
      id: (infantId) => `${infantIdPrefix}-${infantId}-in-lap-selection`,
    },
  ];

  if (!infantsInLap) {
    infantsDropdownOptions.push({
      value: IN_SEAT,
      label: formatMessage({ id: 'in_seat' }),
      id: (infantId) => `${infantIdPrefix}-${infantId}-in-seat-selection`,
    });
  }

  return (
    <div className="row margin-1-b pad-1-lr">
      {infants.map((isInLap, infantIndex) => {
        const infantId = infantIndex + 1;
        const labelHtmlFor = `${moduleId}-room-${roomId}-infant-${infantId}-age`;

        return (
          <div key={labelHtmlFor} className="col-xs-6 pad-0 pad-1-lr">
            <div className="form-group margin-1-b">
              <SelectCustom
                id={labelHtmlFor}
                className={styles.noWrapButton}
                value={isInLap}
                label={formatMessage({ id: 'infant_X' }, { number: infantId })}
                onValueChange={(isOnLap) => updateInfantInLap(roomIndex, infantIndex, isOnLap)}
              >
                {infantsDropdownOptions.map((item) => (
                  <SelectCustomOption
                    aria-label={formatMessage(
                      { id: 'roomInfantSeatAriaLabel' },
                      {
                        isMultiRoom,
                        roomId,
                        infantId,
                        infantSeat: item.label,
                      }
                    )}
                    key={item.value}
                    value={item.value}
                    id={item.id(infantId)}
                    className="dls-bright-blue"
                  >
                    {item.label}
                  </SelectCustomOption>
                ))}
              </SelectCustom>
            </div>
          </div>
        );
      })}
    </div>
  );
};

InfantsVariant.defaultProps = {
  roomIndex: 0,
};

InfantsVariant.propTypes = {
  isMultiRoom: PropTypes.bool,
  roomIndex: PropTypes.number,
};

export default InfantsVariant;
